import { render, staticRenderFns } from "./MenuContainer.vue?vue&type=template&id=0eea3712"
import script from "./MenuContainer.vue?vue&type=script&lang=ts"
export * from "./MenuContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports